import $ from 'jquery';
import ServerTime from 'frontendController/serverTime';
import { MediaQuery } from 'foundation-sites/js/foundation.util.mediaQuery.js'

export default class Countdown {
    constructor(sections, startEpoch, endEpoch, previewEpoch)
    {
        this.startEpoch = startEpoch;
        this.endEpoch = endEpoch;
        this.toDate = new Date(this.endEpoch * 1000);
        this.timer = false;
        this.serverEpoch = 0;
        this.serverTime = new ServerTime();
        this.sections = sections;
        this.previewEpoch = previewEpoch;
    }

    init()
    {
        this.serverTime.init();
        $(document).ready(this.ready());
    }

    ready()
    {
        this.setupSelectors(this.sections);

        $.when(this.serverTime.successfulResponse()).then(() => {
            this.setCountDown();
        });
    }

    setupSelectors(sections)
    {
        $.each(sections, function (index, section) {
            if (section.$selector.length > 0) {
                section['$typeDays'] = section.$selector.find('[data-type="days"]');
                section['$typeHours'] = section.$selector.find('[data-type="hours"]');
                section['$typeMins'] = section.$selector.find('[data-type="mins"]');
                section['$typeSecs'] = section.$selector.find('[data-type="secs"]');
                section['$textDays'] = section.$selector.find('[data-type-text="days"]');
                section['$active'] = section.$selector.find('[data-countdown-active]');
                section['$ended'] = section.$selector.find('[data-countdown-ended]');
            }

            sections[index] = section;
        });

        return sections;
    }

    setCountDown()
    {
        this.serverEpoch = this.previewEpoch ? this.previewEpoch : this.serverTime.getEpoch();
        let currDate = new Date(this.serverEpoch * 1000);
        let diff = this.toDate.getTime() - currDate.getTime();
        let countdown = Math.floor(diff / 1000);
        clearTimeout(this.timer);
        this.displayCountDown(countdown);

        $.when(this.serverTime.successfulResponse()).then(() => {
            this.setCountDown();
        });
    }

    displayCountDown(countdown)
    {
        // see if we're inside the clock start epoch,
        // if no start clock date is set then it will be 0
        // so we'll always be good to go
        if (this.serverEpoch >= this.startEpoch) {
            if (countdown >= 0) {
                let secs = countdown % 60;
                if (secs < 10) secs = '0'+secs;
                let countdown1 = (countdown - secs) / 60;
                let mins = countdown1 % 60;
                if (mins < 10) mins = '0'+mins;
                countdown1 = (countdown1 - mins) / 60;
                let hours = countdown1 % 24;
                let days = (countdown1 - hours) / 24;

                this.countdownHasUpdated(days, hours, mins, secs);
                this.timer = setTimeout(() => {
                    this.displayCountDown((countdown-1));
                }, 999);
            } else {
                this.countdownHasEnded();
                this.timer = setTimeout(() => {
                    this.displayCountDown((countdown-1));
                }, 60000);
            }
        } else {
            // if we're not good to go, wait another minute, and kick things off again
            this.timer = setTimeout(() => {
                this.setCountDown();
            }, 60000);
        }
    }

    countdownHasUpdated(days, hours, mins, secs)
    {
        let me = this;

        $.each(me.sections, function (index, section) {
            if (section.$typeDays && section.$typeDays.length > 0) {
                section.$typeDays.html(me.pad(days));
            }

            if (section.$typeHours && section.$typeHours.length > 0) {
                section.$typeHours.html(me.pad(hours));
            }

            if (section.$typeMins && section.$typeMins.length > 0) {
                section.$typeMins.html(me.pad(mins));
            }

            if (section.$typeSecs && section.$typeSecs.length > 0) {
                section.$typeSecs.html(me.pad(secs));
            }

            Countdown.handleDaysText(section, days);
        });
    }

    countdownHasEnded()
    {
        $.each(this.sections, function (index, section) {
            if (section.$active && section.$active.length > 0) {
                section.$active.hide();
            }

            if (section.$ended && section.$ended.length > 0) {
                section.$ended.hide();
            }
        });
    }

    pad(str)
    {
        let me = this;
        let max = 2;
        str = str.toString();
        return str.length < max ? me.pad("0" + str, max) : str;
    }

    static handleDaysText(section, days)
    {
        // On the top skin banner hide 'Days' if we are in the string format and have no days.
        if (section.$active && section.$active.length > 0 && section.$active.data('clock-location') === 'top-banner') {
            // Text string instead of ticker.
            if (
                // On small devices we show a text string instead of the ticker.
                MediaQuery.is('small only')
            ) {
                // If we have days check if the text should be plural.
                if (days > 0) {
                    section.$textDays.html((days > 1) ? ' days' : ' day');
                    // If we don't have days hide day related elements.
                } else {
                    section.$typeDays.parent().hide();
                    section.$textDays.parent().hide();
                }
            } else {
                section.$typeDays.parent().show();
                section.$textDays.parent().show();
            }
        }
    }
}